const params = new URLSearchParams(window.location.search);
const keysToRemove = []
for(const key of Array.from(params.keys())) {
    if (key.indexOf('FEATURE_') === 0){
        const value = params.get(key);
        if (value) {
            localStorage.setItem(key, value);
            keysToRemove.push(key);
        }
    }
}

if (keysToRemove.length !== 0) {
    for(const key of keysToRemove) {
        params.delete(key);
    }

    if (Array.from(params.keys()).length === 0) {
        window.location.search = '';
    } else {
        window.location.search = `?${params}`;
    }
}

const overridenFeatures: { [key:string]: string } = {}
for(let i = 0; i < localStorage.length; i++) {
    const localStoragekey = localStorage.key(i);
    if (localStoragekey?.indexOf('FEATURE_') === 0) {
        const value = localStorage.getItem(localStoragekey);
        if (value) {
            overridenFeatures[localStoragekey] = value;
        }
    }
}

const dataVisualizationsEnabled = process.env.REACT_APP_FEATURE_ENABLE_DATA_VISUALIZATIONS === 'true' || overridenFeatures['FEATURE_ENABLE_DATA_VISUALIZATIONS'] === 'true';
const starterChecklistEnabled = process.env.REACT_APP_FEATURE_ENABLE_STARTER_CHECKLIST === 'true' || overridenFeatures['FEATURE_ENABLE_STARTER_CHECKLIST'] === 'true';
const publicFormsEnabled = process.env.REACT_APP_FEATURE_PUBLIC_FORMS_ENABLED === 'true' || overridenFeatures['FEATURE_PUBLIC_FORMS_ENABLED'] === 'true';
const publicSubmissionFollowUpsEnabled = process.env.REACT_APP_FEATURE_PUBLIC_SUBMISSION_FOLLOW_UPS_ENABLED === 'true' || overridenFeatures['FEATURE_PUBLIC_SUBMISSION_FOLLOW_UPS_ENABLED'] === 'true';
const participantDataImportEnabled = process.env.REACT_APP_FEATURE_PARTICIPANT_DATA_IMPORT === 'true' || overridenFeatures['FEATURE_PARTICIPANT_DATA_IMPORT'] === 'true';
const programEnrollmentImportEnabled = process.env.REACT_APP_FEATURE_PROGRAM_ENROLLMENT_IMPORT === 'true' || overridenFeatures['FEATURE_PROGRAM_ENROLLMENT_IMPORT'] === 'true';
const assignedUserEnabled = process.env.REACT_APP_FEATURE_ASSIGNED_USER_ENABLED === 'true' || overridenFeatures['FEATURE_ASSIGNED_USER_ENABLED'] === 'true';
const casePlanReportsAssignedInfoEnabled = process.env.REACT_APP_FEATURE_CASE_PLAN_REPORTS_ASSIGNED_INFO === 'true' || overridenFeatures['FEATURE_CASE_PLAN_REPORTS_ASSIGNED_INFO'] === 'true';
const reportsUpgradeEnabled =  process.env.REACT_APP_FEATURE_REPORTS_UPGRADE === 'true' || overridenFeatures['FEATURE_REPORTS_UPGRADE_ENABLED'] === 'true';
const reportsDashboardEnabled = process.env.REACT_APP_FEATURE_REPORTS_DASHBOARD === 'true' || overridenFeatures['FEATURE_REPORTS_DASHBOARD_ENABLED'] === 'true';
const linkedHouseholdParticipantsEnabled = process.env.REACT_APP_FEATURE_LINKED_HOUSEHOLD_PARTICIPANTS === 'true' || overridenFeatures['FEATURE_LINKED_HOUSEHOLD_PARTICIPANTS'] === 'true';
const householdMemberDemographicsReportsEnabled = process.env.REACT_APP_FEATURE_HOUSEHOLD_MEMBER_DEMOGRAPHICS_REPORTS === 'true' || overridenFeatures['FEATURE_HOUSEHOLD_MEMBER_DEMOGRAPHICS_REPORTS'] === 'true';
const householdEditorEnabled = process.env.REACT_APP_FEATURE_HOUSEHOLD_EDITOR === 'true' || overridenFeatures['FEATURE_HOUSEHOLD_EDITOR'] === 'true';
const demographicsOrgSettingsEnabled = process.env.REACT_APP_FEATURE_DEMOGRAPHICS_ORG_SETTINGS === 'true' || overridenFeatures['FEATURE_DEMOGRAPHICS_ORG_SETTINGS'] === 'true';
const bulkHouseholdTrackingEnabled = process.env.REACT_APP_FEATURE_BULK_HOUSEHOLD_TRACKING === 'true' || overridenFeatures['FEATURE_BULK_HOUSEHOLD_TRACKING'] === 'true';
const reportUnansweredFiltersEnabled = process.env.REACT_APP_FEATURE_REPORT_UNANSWERED_FILTERS === 'true' || overridenFeatures['FEATURE_REPORT_UNANSWERED_FILTERS'] === 'true';
const optionalDateOfBirthEnabled = process.env.REACT_APP_FEATURE_OPTIONAL_DATE_OF_BIRTH === 'true' || overridenFeatures['FEATURE_OPTIONAL_DATE_OF_BIRTH'] === 'true';
const configuredRequiredFieldsOrgSettingsEnabled = process.env.REACT_APP_FEATURE_CONFIGURED_REQUIRED_FIELDS_ORG_SETTINGS === 'true' || overridenFeatures['FEATURE_CONFIGURED_REQUIRED_FIELDS_ORG_SETTINGS'] === 'true';
const organizationProfileFieldConfigurationEnabled = process.env.REACT_APP_FEATURE_ORGANIZATION_PROFILE_FIELD_CONFIGURATION === 'true' || overridenFeatures['FEATURE_ORGANIZATION_PROFILE_FIELD_CONFIGURATION'] === 'true';
const participantWorkedWithYearFilterEnabled = process.env.REACT_APP_FEATURE_PARTICIPANT_WORKED_WITH_YEAR_FILTER === 'true' || overridenFeatures['FEATURE_PARTICIPANT_WORKED_WITH_YEAR_FILTER'] === 'true';
const householdIdentifiersEnabled = process.env.REACT_APP_FEATURE_HOUSEHOLD_IDENTIFIERS === 'true' || overridenFeatures['FEATURE_HOUSEHOLD_IDENTIFIERS'] === 'true';
const householdProgramEnrollmentEnabled = process.env.REACT_APP_FEATURE_HOUSEHOLD_PROGRAM_ENROLLMENT === 'true' || overridenFeatures['FEATURE_HOUSEHOLD_PROGRAM_ENROLLMENT'] === 'true';
const bulkParticipantManagementEnabled = process.env.REACT_APP_FEATURE_BULK_PARTICIPANT_MANAGEMENT === 'true' || overridenFeatures['FEATURE_BULK_PARTICIPANT_MANAGEMENT'] === 'true';
const dataExportsEnabled = process.env.REACT_APP_FEATURE_DATA_EXPORTS === 'true' || overridenFeatures['FEATURE_DATA_EXPORTS'] === 'true';
const manageUsersV2Enabled = process.env.REACT_APP_FEATURE_MANAGE_USERS_V2 === 'true' || overridenFeatures['FEATURE_MANAGE_USERS_V2'] === 'true';
const manageProgramsV2Enabled = process.env.REACT_APP_FEATURE_MANAGE_PROGRAMS_V2 === 'true' || overridenFeatures['FEATURE_MANAGE_PROGRAMS_V2'] === 'true';
const sortableReportResultsEnabled = process.env.REACT_APP_FEATURE_SORTABLE_REPORT_RESULTS === 'true' || overridenFeatures['FEATURE_SORTABLE_REPORT_RESULTS'] === 'true';
const sortableMergeSearchEnabled = process.env.REACT_APP_FEATURE_SORTABLE_MERGE_SEARCH === 'true' || overridenFeatures['FEATURE_SORTABLE_MERGE_SEARCH'] === 'true';
const sortableBulkParticipantManagementEnabled = process.env.REACT_APP_FEATURE_SORTABLE_BULK_PARTICIPANT_MANAGEMENT === 'true' || overridenFeatures['FEATURE_SORTABLE_BULK_PARTICIPANT_MANAGEMENT'] === 'true';
const sortableDataExportsEnabled = process.env.REACT_APP_FEATURE_SORTABLE_DATA_EXPORTS === 'true' || overridenFeatures['FEATURE_SORTABLE_DATA_EXPORTS'] === 'true';
const sortableParticipantCasePlansEnabled = process.env.REACT_APP_FEATURE_SORTABLE_PARTICIPANT_CASE_PLANS === 'true' || overridenFeatures['FEATURE_SORTABLE_PARTICIPANT_CASE_PLANS'] === 'true';
const sortableParticipantFilesEnabled = process.env.REACT_APP_FEATURE_SORTABLE_PARTICIPANT_FILES === 'true' || overridenFeatures['FEATURE_SORTABLE_PARTICIPANT_FILES'] === 'true';
const sortableManageUsageEnabled = process.env.REACT_APP_FEATURE_SORTABLE_MANAGE_USAGE === 'true' || overridenFeatures['FEATURE_SORTABLE_MANAGE_USAGE'] === 'true';
const goalLibraryEnabled = process.env.REACT_APP_FEATURE_GOAL_LIBRARY === 'true' || overridenFeatures['FEATURE_GOAL_LIBRARY'] === 'true';

export {
    dataVisualizationsEnabled,
    starterChecklistEnabled,
    publicFormsEnabled,
    publicSubmissionFollowUpsEnabled,
    participantDataImportEnabled,
    programEnrollmentImportEnabled,
    assignedUserEnabled,
    casePlanReportsAssignedInfoEnabled,
    reportsUpgradeEnabled,
    reportsDashboardEnabled,
    linkedHouseholdParticipantsEnabled,
    householdMemberDemographicsReportsEnabled,
    householdEditorEnabled,
    demographicsOrgSettingsEnabled,
    bulkHouseholdTrackingEnabled,
    reportUnansweredFiltersEnabled,
    optionalDateOfBirthEnabled,
    configuredRequiredFieldsOrgSettingsEnabled,
    organizationProfileFieldConfigurationEnabled,
    participantWorkedWithYearFilterEnabled,
    householdIdentifiersEnabled,
    householdProgramEnrollmentEnabled,
    bulkParticipantManagementEnabled,
    dataExportsEnabled,
    manageUsersV2Enabled,
    manageProgramsV2Enabled,
    sortableReportResultsEnabled,
    sortableMergeSearchEnabled,
    sortableBulkParticipantManagementEnabled,
    sortableDataExportsEnabled,
    sortableParticipantCasePlansEnabled,
    sortableParticipantFilesEnabled,
    sortableManageUsageEnabled,
    goalLibraryEnabled
}
